<script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";

/* TODO: Remove this implementation (and style) after SSR activation. Use ESI tags instead in nitro config. */
const route = useRoute();
const isAppView = computed(() => route.query.salesChannel === "06" || route.query.salesChannel === "6");

useHead({
  bodyAttrs: {
    class: computed(() => ({
      "hide-header-footer": isAppView.value,
    })),
  },
});

/* End of temporary implementation */
</script>

<template>
  <div>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>

<style lang="scss">
@use "@ods/lidl-web-vuejs/scss/base.scss" as *;
@use "@ods/lidl-web-vuejs/scss/tokens-lidl.scss" as *;

:root {
  @include ods-theme-root;
  @include ods-typography-base;
  @include ods-theme-lidl-light();

  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }
}

body.hide-header-footer .n-header__root,
body.hide-header-footer .n-footer {
  display: none;
}
</style>
